import React from 'react';
import * as _ from 'lodash'
import {  AxiosInstance } from '../../utils/RequestMethods';
import { WorkerT } from '../../types/Worker';
import config from '../../constants/config';
import { Container, Spinner, Table } from 'react-bootstrap';
import { formatDate } from '../../utils/utilsT';
import moment from 'moment'

import {

    Link,
    useHistory
} from 'react-router-dom'
import { css } from 'glamor';
import TableBootstrap from '../../components/TableBootstrap/TableBootstrap';

import { TdLink } from '../../components/TableBootstrap/TdLink';

import ContentLoader, { Facebook } from "react-content-loader";
import { JobWorkerT } from '../../types/JobWorker';
import { JobT,JobRecordT } from '../../types/Job';



const RowLoader = (props) => (
    <ContentLoader viewBox="0 0 778 116" width={"100%"} style={{
        maxWidth: 300
    }} height={"100%"} {...props}>
        <rect x="37" y="34" rx="0" ry="0" width="0" height="0" />
        {/* <rect x="28" y="29" rx="0" ry="0" width="258" height="32" /> */}
        <rect x="28" y="71" rx="0" ry="0" width="100%" height="32" />
        {/* <rect x="434" y="94" rx="0" ry="0" width="0" height="0" /> */}
        {/* <rect x="29" y="116" rx="0" ry="0" width="749" height="32" /> */}
    </ContentLoader>
);

export type IJobsWokerProps = {
    jobsIsReady: boolean
    worker: WorkerT
    jobs: Array<JobT>
}

export type IJobWorkerItemProps = {
    worker: WorkerT
    job: JobT
}
const style = {
    fixHeightSelect: css({
        height: "100%",
        padding: "0px",
    }),
    inputSearchUsers: css({
        "margin": "0px !important"
    }),
    btnClear: css({
        "cursor": "pointer",
        "top": "10px",
        "position": "absolute",
        "right": "10px",
    }),
    tdLink: css({
        ':hover': { "textDecoration": 'none' },
    })
}



const JobWorkerItem: React.FC<IJobWorkerItemProps> = (props) => {
    const [isLoading, setIsLoading] = React.useState(false);
    const [job, setJob] = React.useState(null);
    let history = useHistory()
    // const [currentJob, setCurrentJob] = React.useState(null)
    const [isReady, setIsReady] = React.useState(false);
    const [jobWorker, setJobWorker] = React.useState<JobWorkerT | null>(null);
    React.useEffect(() => {
        // fetchData()
        setIsReady(true)

    }, [])


    React.useEffect(() => {
        // fetchData()
        setJob(props.job)
        setJobWorker(getWorkerFromCrew(props.job, props.worker.id))
    }, [props.job])


    const fetchData = async () => {
        setIsLoading(true)
        AxiosInstance.get(`${config.url.jobs}/${props.job.id}`).then((res) => {
            setIsLoading(false)
            if (res && res.data) {
                setJob(res.data)
            }
        }).catch((error) => {
            setIsLoading(false)
        })
    }

    /**
     *
     * @param job
     * @param workerId
     */
    const getWorkerFromCrew = (job: JobT, workerId): JobWorkerT => {
        const crew = job.crew && _.isArray(job.crew) ? job.crew : []
        const find = crew.find((x) => x.id == workerId)

        return find
    }


    if (!isReady || !job) {
        return (
            <td colSpan={4}>
                <Container className="mt-5 ">
                    <div className="d-flex flex-column align-items-center justify-content-center">
                        <span>Loading...</span>
                        <Spinner animation="border" variant="success" />
                    </div>
                </Container>
            </td>
        )
    }

    /**
    *
    * @param id
    */
    const generateUrlJob = (job: JobT) => {
        return `/job/${job.id}`
    }

    // const to = generateUrlJob(job)


    return (
        <>
            {/* <Td to={to}>{job.lastContactDate && moment.utc(job.lastContactDate).local().format('MM/DD/YYYY HH:mm:ss')}</Td> */}
            <TdLink to={generateUrlJob(job)}>{job.scheduledDate && moment.utc(job.scheduledDate).local().format('MM/DD/YYYY')}</TdLink>

            <TdLink to={generateUrlJob(job)}></TdLink>
            {/* <Td to={to}>{job.date && moment(job.date).format('MM/DD/YYYY HH:mm:ss')}</Td> */}
            <TdLink to={generateUrlJob(job)}>{job.jobStatus.split(' ').map(item => item.charAt(0).toUpperCase() + item.substring(1)).join(' ')}</TdLink>
            <TdLink to={generateUrlJob(job)}>{job.jobType.split('_').map(item => item.charAt(0).toUpperCase() + item.substring(1)).join(' ')}</TdLink>
            {/* <Td to={to}>{`${job.client.phone}`}</Td> */}
            {/* <Td to={to}>{`${job.client.firstName} ${job.client.lastName}`}</Td> */}
            <TdLink to={generateUrlJob(job)}>{job.locations && job.locations[0] && job.locations[0].address}</TdLink>

            {/* <Td to={ generateUrlJob(job)}>{parseCrew(job)}</Td> */}

        </>
    )
}


const JobsWoker: React.FC<IJobsWokerProps> = (props) => {
    let history = useHistory()
    if (props.worker.jobs.length == 0) {
        return (
            <p>
                {props.worker.firstName} {props.worker.lastName} has not worked any jobs yet.
            </p>
        )
    }

    /**
      *
      * @param jobId
      */
    const openJob = (jobId: number): void => {
        history.push({
            pathname: '/job/' + jobId
        })
    }

    return (
        <div>
            {!props.jobsIsReady ?
                <div>

                    <TableBootstrap<JobRecordT>
                        columns={['Scheduled Date', "Pay", 'Status', 'Type', 'Address']}
                        data={props.worker.jobs}
                        onClickItem={(item) => {
                            openJob(item.id)
                        }}
                        // customRenderColumn={(item, index) => {
                        //     return (
                        //         <th key={index} style={{ width: 300 }}>{item}</th>
                        //     )
                        // }}
                        renderRowItem={(job, index) => {
                            return (
                                <>
                                    <td > <div style={{ maxWidth: 300 }}> <RowLoader />  </div> </td>
                                    <td > <div style={{ maxWidth: 300 }}> <RowLoader />  </div> </td>
                                    <td > <div style={{ maxWidth: 300 }}> <RowLoader />  </div> </td>
                                    <td > <div style={{ maxWidth: 300 }}> <RowLoader />  </div> </td>
                                    <td > <div style={{ maxWidth: 300 }}> <RowLoader />  </div> </td>
                                </>
                            )
                        }}
                    />
                    {/* {props.worker.jobs.map((item, index) => {
                        return (
                            <div>
                            </div>
                        )
                    })} */}
                </div>
                : <TableBootstrap<JobT>
                columns={['Scheduled Date', "Pay", 'Status', 'Type', 'Address']}
                    data={props.jobs}
                    onClickItem={(item) => {
                        openJob(item.id)
                    }}
                    renderRowItem={(job, index) => {
                        return (
                            <JobWorkerItem job={job} worker={props.worker} />
                        )
                    }}
                />}

        </div>
    );
}
export default JobsWoker;
export { JobsWoker };
